var map = {
	"./insta.svg": 589,
	"./insta1.svg": 590,
	"./linkedin.svg": 591,
	"./linkedin0.svg": 592,
	"./twitter.svg": 593,
	"./twitter3.svg": 594,
	"./youtube.svg": 595,
	"./youtube2.svg": 596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 362;